import { getWithParamsRequest } from '@rideiq/api/utils/provider';
import { ApiResponse } from '@rideiq/api/utils/responseTransform';

import { SisSearchResponse, SisStudentDetails } from '../../features/RiderCreationModal/SisImportBanner/types';

export const searchSisStudents = (
  query: string,
  page: number = 1,
  signal?: AbortSignal
): Promise<ApiResponse<SisSearchResponse>> => {
  return getWithParamsRequest<SisSearchResponse>(
    'sis_records/students',
    {
      query: query,
      page,
      per_page: 10,
    },
    signal
  );
};

export const getSisStudentById = (
  studentId: number,
  signal?: AbortSignal
): Promise<ApiResponse<{ student: SisStudentDetails }>> => {
  return getWithParamsRequest<{ student: SisStudentDetails }>(`sis_records/students/${studentId}`, {}, signal);
};
